import script from "./SessionDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./SessionDetailModal.vue?vue&type=style&index=0&id=24e94244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e94244"]])

export default __exports__